(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milwaukee-packout-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('packout-builder')) {
    class PackoutBuilder extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-packout-product]'));
        this.search = this.querySelector('[data-packout-search]');
        this.filters = Array.from(this.querySelectorAll('[data-packout-filter]'));
        this.checkboxes = Array.from(this.querySelectorAll('[data-packout-select]'));
        this.countOutput = this.querySelector('[data-packout-count]');
        this.totalOutput = this.querySelector('[data-packout-total]');
        this.addButton = this.querySelector('[data-packout-add]');
        this.status = this.querySelector('[data-packout-status]');
        this.activeFilter = 'all';

        this.search?.addEventListener('input', () => this.applyFilters());
        this.filters.forEach((button) => {
          button.addEventListener('click', () => {
            this.activeFilter = button.dataset.packoutFilter;
            this.filters.forEach((filter) => filter.classList.toggle('is-active', filter === button));
            this.applyFilters();
          });
        });
        this.checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', () => this.updateSummary());
          checkbox.closest('[data-packout-product]')?.querySelector('[data-packout-quantity]')?.addEventListener('input', () => this.updateSummary());
        });
        this.addButton?.addEventListener('click', () => this.addSelected());
        this.updateSummary();
      }

      applyFilters() {
        const term = this.search?.value.trim().toLowerCase() || '';
        this.cards.forEach((card) => {
          const categoryMatches = this.activeFilter === 'all' || card.dataset.category === this.activeFilter;
          const searchMatches = !term || card.dataset.search.includes(term);
          card.hidden = !(categoryMatches && searchMatches);
        });
      }

      selectedItems() {
        return this.checkboxes.filter((checkbox) => checkbox.checked).map((checkbox) => {
          const card = checkbox.closest('[data-packout-product]');
          const quantityInput = card.querySelector('[data-packout-quantity]');
          const quantity = Math.max(1, Math.min(20, Number(quantityInput.value) || 1));
          quantityInput.value = String(quantity);
          return {
            id: Number(checkbox.dataset.variantId),
            quantity,
            price: Number(checkbox.dataset.price)
          };
        });
      }

      updateSummary() {
        const items = this.selectedItems();
        const units = items.reduce((total, item) => total + item.quantity, 0);
        const subtotal = items.reduce((total, item) => total + item.price * item.quantity, 0);
        const moneyFormat = window.Shopify?.currency?.active === 'USD' ? 'USD' : 'CAD';
        this.countOutput.textContent = String(units);
        this.totalOutput.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency: moneyFormat }).format(subtotal / 100);
        this.addButton.disabled = items.length === 0;
        this.status.textContent = '';
      }

      async addSelected() {
        const items = this.selectedItems().map(({ id, quantity }) => ({ id, quantity }));
        if (!items.length) {
          this.status.textContent = this.dataset.emptyMessage;
          return;
        }

        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-busy', 'true');
        this.status.textContent = '';

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.status.textContent = this.dataset.errorMessage;
          this.addButton.disabled = false;
          this.addButton.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('packout-builder', PackoutBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milwaukee-solutions-landing"] && !Shopify.designMode) return;
  try {
    
  class MilwaukeeSolutions extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-solutions-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-solutions-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectSystem(tab.dataset.solutionsTab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event));
      });

      const requestedSystem = new URLSearchParams(window.location.search).get('system');
      if (requestedSystem && this.tabs.some((tab) => tab.dataset.solutionsTab === requestedSystem)) {
        this.selectSystem(requestedSystem, false);
      }
    }

    selectSystem(system, updateUrl = true) {
      this.tabs.forEach((tab) => {
        const selected = tab.dataset.solutionsTab === system;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.solutionsPanel !== system;
      });

      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('system', system);
        window.history.replaceState({}, '', url);
      }
    }

    handleKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const nextIndex = (currentIndex + direction + this.tabs.length) % this.tabs.length;
      const nextTab = this.tabs[nextIndex];
      this.selectSystem(nextTab.dataset.solutionsTab);
      nextTab.focus();
    }
  }

  if (!customElements.get('milwaukee-solutions')) {
    customElements.define('milwaukee-solutions', MilwaukeeSolutions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-beast-automotive-lighting"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.tb-auto');

    sections.forEach((section) => {
      const filters = section.querySelectorAll('[data-filter]');
      const products = section.querySelectorAll('[data-system]');
      const count = section.querySelector('[data-result-count]');

      if (!filters.length || !products.length) return;

      const updateProducts = (filter) => {
        let visible = 0;

        products.forEach((product) => {
          const shouldShow = filter === 'all' || product.dataset.system === filter;
          product.hidden = !shouldShow;
          if (shouldShow) visible += 1;
        });

        if (count) count.textContent = visible;
      };

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          filters.forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });

          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          updateProducts(button.dataset.filter);
        });
      });

      updateProducts('all');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-beast-fall-workwear"] && !Shopify.designMode) return;
  try {
    
  function initializeFallWorkwear(root) {
    if (!root || root.dataset.fallWorkwearReady === 'true') return;

    const buttons = Array.from(root.querySelectorAll('[data-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-product-card]'));
    const status = root.querySelector('[data-filter-status]');

    if (!buttons.length || !cards.length) return;

    root.dataset.fallWorkwearReady = 'true';

    function applyFilter(filter, label) {
      let visibleCount = 0;

      cards.forEach((card) => {
        const categories = (card.dataset.category || '').split(' ');
        const showCard = filter === 'all' || categories.includes(filter);
        card.hidden = !showCard;
        if (showCard) visibleCount += 1;
      });

      buttons.forEach((button) => {
        const isActive = button.dataset.filter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (status) {
        const showingLabel = root.dataset.showingLabel || 'Showing';
        const productLabel = root.dataset.productLabel || 'products';
        status.textContent =
          filter === 'all'
            ? `${showingLabel} ${visibleCount} ${productLabel}`
            : `${showingLabel} ${visibleCount} ${label.toLowerCase()} ${productLabel}`;
      }
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.filter, button.textContent.trim()));
    });

    applyFilter('all', buttons[0].textContent.trim());
  }

  function initializeAllFallWorkwear(container) {
    const scope = container || document;
    if (scope.matches && scope.matches('[data-fall-workwear]')) {
      initializeFallWorkwear(scope);
    }
    scope.querySelectorAll('[data-fall-workwear]').forEach(initializeFallWorkwear);
  }

  initializeAllFallWorkwear(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllFallWorkwear(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-beast-heated-gear"] && !Shopify.designMode) return;
  try {
    
  function initializeHeatedGear(root) {
    if (!root || root.dataset.heatedGearReady === 'true') return;

    const buttons = Array.from(root.querySelectorAll('[data-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-product-card]'));
    const status = root.querySelector('[data-filter-status]');

    if (!buttons.length || !cards.length) return;

    root.dataset.heatedGearReady = 'true';

    function applyFilter(filter, label) {
      let visibleCount = 0;

      cards.forEach((card) => {
        const showCard = filter === 'all' || card.dataset.category === filter;
        card.hidden = !showCard;
        if (showCard) visibleCount += 1;
      });

      buttons.forEach((button) => {
        const isActive = button.dataset.filter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (status) {
        const showingLabel = root.dataset.showingLabel || 'Showing';
        const productLabel = root.dataset.productLabel || 'products';
        status.textContent =
          filter === 'all'
            ? `${showingLabel} ${visibleCount} ${productLabel}`
            : `${showingLabel} ${visibleCount} ${label.toLowerCase()} ${productLabel}`;
      }
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.filter, button.textContent.trim()));
    });

    applyFilter('all', buttons[0].textContent.trim());
  }

  function initializeAllHeatedGear(container) {
    const scope = container || document;
    if (scope.matches && scope.matches('[data-heated-gear]')) {
      initializeHeatedGear(scope);
    }
    scope.querySelectorAll('[data-heated-gear]').forEach(initializeHeatedGear);
  }

  initializeAllHeatedGear(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllHeatedGear(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
